var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_user-agent.js
// module id = KrKR
// module chunks = 1